$(function () {
    // *** Common ***
    function replacePlaceholder(url, placeholder, value) {
        url = url.replace(placeholder, value);
        url = url.replace(encodeURI(placeholder), value);
        return url;
    }

    const hasValue = (value) => {
        return typeof value !== "undefined" && value.toString().trim() !== "";
    };

    const firstWithValue = (first, second) => {
        return hasValue(first) ? first : second;
    };

    // *** Header ***
    $(".nav-element .heading-summary").click(function () {
        let navElement = $(this).closest(".nav-element");
        $(navElement).toggleClass("view-mode-open");
    });

    $(".nav-element .heading-summary a.clear-link").click(function (event) {
        if (typeof window !== 'undefined') { window.location = event.currentTarget.href; }
        return false;
    });

    // *** Ad Type ***
    $(".adtype-element .adtype-actions button.go").click(function () {
        let form = $(this).closest('.adtype-element').find('.adtype-selection form');
        form.submit();
    });

    // *** Aspect ***
    $(".aspect-navigation-element .view-link").click(function () {
        $(this).hide();
        $(this).siblings(".view-link").show();
        $(this).siblings(".default-facets").children("li.facet-hidden").toggleClass("show");
    });

    $(".aspect-navigation-element .add-another-link").click(function () {
        $(this).hide();
        $(this).siblings(".add-another-link").hide();
        $(this).siblings(".add-another-content").show();
    });

    // *** Keyword ***
    $(".keyword-element .keyword-selection button.go").click(function () {
        let keywordEle = $(this).siblings("input");
        let keywordValue = $(keywordEle).val();
        if (keywordValue === "") {
            alert(keywordEle.data("msgRequired"));
            return;
        }

        let placeholder = $(this).data("placeholder");
        let expressionUrl = $(this).data("expression-url");
        let url = replacePlaceholder(expressionUrl, placeholder, keywordValue);
        if (typeof window !== 'undefined') { window.location = url; }
    });

    $(".keyword-element .keyword-selection input").keypress(function (e) {
        if (e.which === 13) {
            $(this).siblings("button.go").click();
        }
    });

    // *** Sanitize Range ***
    function sanitizeRangeValues(value) {
        var localeCulture = document.documentElement.lang;
        localeCulture = localeCulture.toString().substring(0, 2);
        var sanitizedValue = value.toString().toInteger(localeCulture);
        return sanitizedValue;
    }

    String.prototype.toInteger = function (localeCulture) {
        var localizedValue = 'en';
        if (localeCulture !== 'en') {
            localizedValue = this.replace(/[^\d,]/g, '');
            localizedValue = parseInt(localizedValue);
        }
        else {
            localizedValue = this.replace(/[^\d.]/g, '');
            localizedValue = parseInt(localizedValue);
        }
        return localizedValue;
    };

    // *** Range ***
    $(".range-element .range-actions button.go").click(function () {
        let lowerPlaceholder = $(this).data("lower-placeholder");
        let upperPlaceholder = $(this).data("upper-placeholder");
        let expressionUrl = $(this).data("expression-url");

        let rangeElement = $(this).closest(".range-element");
        const minInput = $(rangeElement).find(".range-min input"),
            maxInput = $(rangeElement).find(".range-max input");
        
        let lowerValue = firstWithValue(minInput.data("value"), minInput.val());
        let upperValue = firstWithValue(maxInput.data("value"), maxInput.val());

        if (lowerValue === "Min" || lowerValue === "")
            lowerValue = "";
        else
            lowerValue = sanitizeRangeValues(lowerValue);
            //lowerValue = parseInt(lowerValue);


        if (upperValue === "Max" || upperValue === "")
            upperValue = "";
        else
            upperValue = sanitizeRangeValues(upperValue);
            //upperValue = parseInt(upperValue);

        if (lowerValue !== "" && upperValue !== "") {
            if (lowerValue > upperValue) {
                let tempLowerValue = lowerValue;
                lowerValue = upperValue;
                upperValue = tempLowerValue;
            }
        }
        
        let url = expressionUrl;
        url = replacePlaceholder(url, lowerPlaceholder, lowerValue);
        url = replacePlaceholder(url, upperPlaceholder, upperValue);
        if (typeof window !== 'undefined') { window.location = url; }
    });

    $("#retail-nav-component .autocomplete-dropdown i").click(function () {
        const elm = $(this)
            .closest("#retail-nav-component .autocomplete-dropdown")
            .find("ul");
        const isHidden = elm.is(":hidden");

        $("#retail-nav-component .autocomplete-dropdown ul").hide();

        isHidden ? $(elm).show() : $(elm).hide();
    });

    $("#retail-nav-component .autocomplete-dropdown").click(function (e) {
        e.stopPropagation();
    });

    $(document).click(function () {
        $("#retail-nav-component .autocomplete-dropdown ul").hide();
    });

    $("#retail-nav-component .autocomplete-dropdown input").on("keyup", function (e) {
        $(this).data("value", $(this).val());
    });

    $("#retail-nav-component .autocomplete-dropdown li").click(function () {
        const text = $(this).data("text");
        const value = $(this).data("value");
        const input = $(this).closest("#retail-nav-component .autocomplete-dropdown").find("input");

        input.val(text);
        input.data("value", value);

        $(this).closest("ul").toggle();
    });

    // *** poi / postcode ***
    $(".poi-element .poi-actions button.go").click(function () {
        let locationPlaceholder = $(this).data("location-placeholder");
        let distanceKmPlaceholder = $(this).data("distinkms-placeholder");
        let expressionUrl = $(this).data("expression-url");

        let poiElement = $(this).closest(".poi-element");
        let postcode = $(poiElement).find(".poi-selection input").val();
        let distanceInKm = $(poiElement).find(".poi-selection select").val();

        if (isNaN(postcode) || postcode.length !== 4) {
            alert('Please enter valid postcode.');
            $(poiElement).find(".poi-selection input").focus();
            return false;
        }

        let url = expressionUrl;
        url = replacePlaceholder(url, locationPlaceholder, postcode);
        url = replacePlaceholder(url, distanceKmPlaceholder, distanceInKm);
        if (typeof window !== 'undefined') { window.location = url; }
    });

});